module.exports = __webpack_public_path__ + "img/sia.c357989e.png";